import { STORAGE_KEYS, StorageService } from './../../services/storage.service';
import { AuthService } from './../../shared/services/auth.service';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Component, inject, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { SettlementsService } from 'src/app/services/settlements.service';
import { User } from '../../models/user';

import { faCircleNotch } from '@fortawesome/free-solid-svg-icons';
import { faLock } from '@fortawesome/free-solid-svg-icons';

import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';

@Component({
  selector: 'app-sign-in',
  template: `
    <div class="d-flex pt-4">
      <div class="flex-fill flex-column text-center">
        <div>
          <img src="assets/images/logo-zazz.png" class="img-fluid mt-5 text-center pt-5" width="74px" alt="ZAZZ">
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-center">
      <div class="flex-grow-2 p-3 mt-5" style="width: 320px;">
        <h2 class="text-center mb-0 mt-5 mb-3">Bienvenido</h2>
        <form [formGroup]="loginForm" (ngSubmit)="login()">
          <div class="form-group text-start mt-5">
            <label for="email" class="text-sm sr-only d-none">Correo electrónico</label>
            <input type="text" formControlName="email" class="form-control border-1 rounded-0 border-dark pt-3 pb-3" placeholder="Correo electrónico" #userName required>
            <div *ngIf="lf['email'].touched && lf['email'].invalid">
              <div *ngIf="lf['email'].errors?.['required']" class="text-danger text-sm">El correo electrónico es requerido.</div>
              <div *ngIf="lf['email'].errors?.['email']" class="text-danger text-sm">El correo electrónico no es válido</div>
            </div>
          </div>
          <div class="form-group mt-4">
            <label for="password" class="text-sm sr-only d-none">Contraseña</label>
            <input type="password" formControlName="password" class="form-control border-1 rounded-0 border-dark pt-3 pb-3" placeholder="Contraseña" #userPassword required>
            <div *ngIf="lf['password'].touched && lf['password'].invalid">
              <div *ngIf="lf['password'].errors?.['required']" class="text-danger text-start text-sm">La contraseña es requerida.</div>
            </div>
          </div>
          <div class="form-group mt-5">
            <button type="submit" class="btn btn-zazz-dark shadow-sm btn-lg w-100 rounded-0 pt-3 pb-3">
              <fa-icon [icon]="faCircleNotch" animation="spin" *ngIf="loading" class="text-secondary me-2"></fa-icon>
              <fa-icon [icon]="faLock" *ngIf="!loading" class="text-light me-2"></fa-icon>
              Entrar
            </button>
          </div>
          <div class="form-group mt-3">
            <p class="text-center text-sm">V {{version}}</p>
            <div class="forgotPassword mt-5 text-center">
              <a routerLink="/forgot-password" class="text-sm">¿Olvidaste tu contraseña?</a>
            </div>
          </div>
        </form>
      </div>
    </div>
    <div class="d-flex justify-content-center">
      <div class="mt-5 pt-5">
        <a href="https://zazz.mx/aviso-de-privacidad/" class="text-sm mt-5">Aviso de privacidad</a> <span class="text-sm mt-5 ps-3 pe-3"> | </span>
        <a href="https://zazz.mx/terminos-y-condiciones/" class="text-sm mt-5">Términos y condiciones</a>
      </div>
    </div>

    <!-- h1 class="text-light text-center mt-4">SISTEMA ZAZZ</!-->
    <!-- p class="text-light text-sm mt-5 pt-3">Todos los derechos reservados © 2024</!-->

    
  `,
  styleUrls: []
})
export class SignInComponent implements OnInit {
  loginForm!: FormGroup;
  loading: boolean = false;

  protected version = environment.app_version;

  emailPattern = "^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$";

  faCircleNotch = faCircleNotch;
  faLock = faLock;
  storageService = inject(StorageService);
  constructor(
    public authService: AuthService,
    private fb: FormBuilder,
    private toastr: ToastrService,
    private store: SettlementsService,
    private router: Router
  ) { }

  get lf() {
    return this.loginForm.controls;
  }

  get email() {
    return this.loginForm.get('email');
  }
  
  ngOnInit(): void { 
    if (this.storageService.getItem(STORAGE_KEYS.TOKEN)) {
      this.router.navigate(['dashboard']);
    }

    this.initLoginForm();
  }

  private initLoginForm(): void {
    this.loginForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', Validators.required]
    });
  }

  login () {
    this.loading = true;
    if (this.loginForm.invalid) {
      this.toastr.error('No está completa la información.', 'Error');
      this.loading = false;
      return;
    }

    let payload = {
      user: {
        email: this.loginForm.value.email,
        password: this.loginForm.value.password
      }
    };

    this.store.login(payload).subscribe({
      next: async (data: any) => {
        // console.log(data);
        if (data.status.code == 200) {        
          if (await this.SetUserData(data)) {
            this.store.getProfile(data.data.profile_id).subscribe({
              next: (profileData: any) => {
                this.storageService.saveItem(STORAGE_KEYS.PROFILE, { profile: profileData})

                this.store.getRole(data.data.role_id).subscribe({
                  next: (roleData: any) => {
                    this.storageService.saveItem(STORAGE_KEYS.ROLE, { role: roleData});
                    this.storageService.saveItem(STORAGE_KEYS.PERMISSIONS, roleData.permissions);
                    this.storageService.saveItem(STORAGE_KEYS.USERTYPE, 'admin');

                    this.router.navigate(['dashboard']);
                  },
                  error: (error: any) => {
                    console.error('Error cargando el rol:', error);
                    this.toastr.error('Error cargando el rol', 'Error');
                    this.loading = false;
                  }
                });
              },
              error: (error: any) => {
                console.error('Error cargando el perfil:', error);
                this.toastr.error('Error cargando el perfil', 'Error');
                this.loading = false;
              }
            });
          }
        } else {        
          window.alert(data.message);
        }
      },
      error: (error: any) => {
        // console.log(error);
        this.toastr.error('Credenciales equivocadas por favor verifica e intenta de nuevo.', 'Error');
        this.loading = false;
      }
    });

  }

  async SetUserData(user: any) {
    const userData: User = {
      id: user.data.id,
      email: user.data.email,
      name: user.data.name,
      last_name: user.data.last_name,
      jti: user.data.jti,
      role_id: user.data.role_id,
      settlement_id: user.data.settlement_id,
      profile_id: user.data.profile_id,
      avatar: user.avatar
    };
    this.storageService.saveItem(STORAGE_KEYS.TOKEN, user.token);
    this.storageService.saveItem(STORAGE_KEYS.USER, userData);

    return true;
  }
}
